export default function setAuthClasses(isAuthenticated) {
  // console.log('setAutClasses', isAuthenticated);
  if (isAuthenticated) {
    document.getElementsByTagName('body')[0].classList.add('isAuthenticated');
    document.getElementById('root').classList.add('isAuthenticated');
  } else {
    document
      .getElementsByTagName('body')[0]
      .classList.remove('isAuthenticated');
    document.getElementById('root').classList.remove('isAuthenticated');
  }
}



// WEBPACK FOOTER //
// ./src/utils/ui-utils.js